/**
 * Base URL for Auth0 `redirect_uri` and org URL display.
 * In development, uses the browser origin so any localhost port works without
 * syncing `VITE_AUTH0_BASE_URL`. Production prefers the env value (inlined at build)
 * when set, then falls back to the current origin.
 */
export function getAuth0AppBaseUrl(): string {
  if (import.meta.env.DEV && typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  const envUrl = (import.meta.env.VITE_AUTH0_BASE_URL as string | undefined)?.trim();
  if (envUrl) return envUrl;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/** Host (with port if non-default) for display, e.g. `app.driverai.com` or `localhost:3003`. */
export function getAuth0AppHostDisplay(): string {
  const base = getAuth0AppBaseUrl();
  if (!base) return 'app.driverai.com';
  try {
    return new URL(base).host;
  } catch {
    return base.replace(/^https?:\/\//, '');
  }
}
